import React, { FC, memo, useEffect } from 'react'
import { Grid } from '@mui/material'
import { Theme } from '@mui/material/styles'
import { makeStyles } from '@mui/styles'
import { useDispatch, useSelector } from 'react-redux'
import { Modal } from '../../../../../../components/Dashboard/Modal'
import { FundAccount } from './FundAccount'
import { getUserWalletListRequest } from '../../../../../../store/actions'
import { userWalletsListEnumSelector } from '../../../../../../store/selectors'

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    // width: 672,
    boxSizing: 'border-box',
    '& > div': {
      paddingTop: 0,
      marginTop: theme.spacing(-1),
    },
  },
}))

interface IFundAccountPopup {
  isOpen: boolean
  modalClose: () => void
}

export const FundAccountPopup: FC<IFundAccountPopup> = ({ isOpen, modalClose }) => {
  const classes = useStyles()
  const walletEnums = useSelector(userWalletsListEnumSelector)
  const dispatch = useDispatch()

  useEffect(() => {
    if (isOpen) {
      dispatch(getUserWalletListRequest())
    }
  }, [isOpen, dispatch])

  return (
    <Modal title="Fund Account" isOpen={isOpen} modalClose={modalClose} actions={walletEnums.length}>
      <Grid container className={classes.container}>
        <FundAccount onSuccess={modalClose} walletEnums={walletEnums} />
      </Grid>
    </Modal>
  )
}

export const MemoFundAccountPopup = memo(FundAccountPopup)
